import { FC } from 'react';
import { InvoiceManagement } from 'components/InvoiceManagement';
import { Page } from 'layouts/Page';

export const InvoiceManagementPage: FC = () => {
	return (
		<Page title="Invoice Management – EAS Control Center">
			<InvoiceManagement />
		</Page>
	);
};
